<template>
    <data-filter v-model="query.perPage" v-if="query">
        <t-select slot-scope="{ set }" @input="" :value="Number(query.perPage)" @input="set" :options="perPage" :allow-empty="false"></t-select>
    </data-filter>
</template>

<script>
export default {
    props: {
        query: {
            type: Object,
            required: true,
        },
        perPage: {
            type: Array,
            default: () => [10, 25, 50],
        },
    },
};
</script>
